import { render, staticRenderFns } from "./ExamManagement.vue?vue&type=template&id=754383f4&scoped=true&"
import script from "./ExamManagement.vue?vue&type=script&lang=js&"
export * from "./ExamManagement.vue?vue&type=script&lang=js&"
import style0 from "./ExamManagement.vue?vue&type=style&index=0&id=754383f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754383f4",
  null
  
)

export default component.exports